// Copyright © 2021 Move Closer

import { Component, Prop, Ref, Vue } from 'vue-property-decorator'

import { ActionButton, IActionButton } from '../ActionButton'
import ArticleActionItem from './partials/ArticleActionItem'
import { BootstrapPopover } from '../../../dsl/bootstrap'

/**
 * @author Sebastian Dziechciarz, Stanisław Gregor
 */
@Component({
  name: 'ArticleActions',
  components: { ActionButton, ArticleActionItem, BootstrapPopover },
  template: `
    <ul class="article-actions list-inline" ref="container">
      <li v-for="(action, i) in actions" :key="i" class="article-actions__item"
          :class="{ 'd-none d-md-inline-block': action.hideForMobile }">
        <BootstrapPopover v-if="action.children" position="right" triggerMode="click">
          <div slot="content">
            <ul class="article-actions__list list-inline">
              <ArticleActionItem v-for="item in action.children" :key="item.icon" v-bind="item"/>
            </ul>
          </div>
          <div slot="trigger">
            <ActionButton v-bind="action" />
          </div>
        </BootstrapPopover>

        <ActionButton v-else v-bind="action" />
      </li>
    </ul>
  `
})
export class ArticleActions extends Vue {
  @Prop({ type: Array, required: true })
  public readonly actions!: IActionButton[]

  @Ref('container')
  private readonly containerRef!: HTMLDivElement

  private resizeObserver?: ResizeObserver

  mounted () {
    this.watchSize()
  }

  beforeDestroy () {
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.containerRef)
    }
  }

  protected watchSize (): void {
    this.resizeObserver = new ResizeObserver(([entry]) => {
      if (entry.contentBoxSize?.length) {
        this.getHeight()
      }
    })

    this.resizeObserver.observe(this.containerRef)
  }

  protected getHeight (): void {
    const height: string | undefined = typeof this.containerRef !== 'undefined'
      ? this.containerRef.clientHeight + 'px' : undefined

    if (typeof height !== 'undefined') {
      document.documentElement.style.setProperty('--actions-height', height)
    }
  }
}
